import { render } from "./TimePopupRealtime.vue?vue&type=template&id=595ef724"
import script from "./TimePopupRealtime.vue?vue&type=script&lang=js"
export * from "./TimePopupRealtime.vue?vue&type=script&lang=js"

import exportComponent from "/root/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__